window.initCareerValues = function(sectionId) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    },
    { threshold: 0.1 }
  );

  section.querySelectorAll('.career-values-reveal').forEach((el) => observer.observe(el));
};

// Auto-initialize all career-values sections on page load
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('[id^="shopify-section-"]');
    sections.forEach(function(section) {
      if (section.querySelector('.career-values-section')) {
        window.initCareerValues(section.id);
      }
    });
  });
})();
